// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"951dd07a","199":"951dd07a","645":"ee32798d"}[chunkId] + ".chunk.css";
};